<template>
  <div class="ivt_ifarme">
    <audio ref="audio"  loop src="@/assets/mp.mp3"></audio>
    <div class="pc">
      <div v-show="bartype" class="ivt_title_div">
        <div class="ivt_title">
          <img src="@/assets/logo.png" />
          <div style="bottom: 0px; position: absolute">
            <p style="    margin-block-start: 0em;margin-block-end: 0em;margin: 0px;font-size: 1vw;font-weight: 600;white-space: nowrap;">{{roomname == "5BR-2" ? "ELEGANCE" :"CONTEMPORARY"}} | {{roomname}}</p>
          </div>
        </div>
        <swiper ref="hits" class="swiper" navigation :options="swiperOption">
          <swiper-slide
            v-show="slide.type == 0" v-for="(slide, indexs) in ivtData[scenename]"
            :key="indexs">
            <template>
              <div class="swiper-slide-content" @click="setimg(slide),rightbtn=0,leftindex=0">
                <img
                  v-bind:src="`${GLOBAL.service}img/043img/${roomname}/ivt/${scenename}/${slide.lct}/room_b.jpg`"
                  style="max-width: 100%"
                />
                <!-- `${this.GLOBAL.service}img/043img/ivt/${this.scenename}/${this.lct}/room_` -->
                <span class="slidetext" >{{
                  slide.name
                }}</span>
              </div>
            </template>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" @click="prev" slot="button-prev">
            <img style="width: 30px" src="@/assets/button/left.png" alt />
          </div>
          <div class="swiper-button-next" @click="next" slot="button-next">
            <img style="width: 30px" src="@/assets/button/right.png" alt />
          </div>
        </swiper>
        <div class="swiper_back_btn">
          <button @click="bartype = !bartype">X</button>
        </div>
      </div>
      <div class="title_off" :class="{ title_on: bartype }">
        <img
          v-if="bartype"
          @click="bartype = !bartype"
          style="width: 30px"
          src="@/assets/button/off.png"
          alt
        />
        <img
          v-else
          @click="bartype = !bartype"
          style="width: 30px"
          src="@/assets/button/no.png"
          alt
        />
      </div>

      <div class="pc_btn_group">
        <div
          v-show="scenename != 'structure'"
          class="btn"
          @click="setScene('SoftOutfit', scenename)"
        >
          <img src="@/assets/button/weather.png" alt />
          <p>DAY/NIGHT<br>SCENES</p>
        </div>

        <div class="btn" @click="setScene('HardOutfit', scenename)">
          <img src="@/assets/button/brush.png" alt />
          <p>TOP/<br>RENOVATED</p>

        </div>
        <div class="btn" @click="soundBtn">
          <img v-if="audioType" src="@/assets/button/sound.png" alt />
          <img v-else src="@/assets/button/mute.png" alt />
          <p>SOUND<br>ON/OFF</p>

        </div>
        <!-- <div class="btn">
          <img src="@/assets/button/pop1.png" alt />
        </div>-->

        <div class="btn" @click="goPage('/')">
          <img src="@/assets/button/home.png" alt />
          <p>HOME</p>
        </div>
      </div>
    </div>
    <div style="position: absolute;bottom: 50px;z-index: 999;">{{NowModelXYZ}}</div>
    <div class="room_content" @click="bartype =false">
      <div v-show="loadingindex" class="loading">loading。。。</div>
      <div class="floorplan middle" :class="{clickfloorplan:leftbtn}" >
        <!-- 左下角户型图 -->

        <div v-show="leftbtn" class="leftbtns middle" @click="leftbtn=false">X</div>
        <div class="middle" style="width:100%;height:100%" @click="leftbtn=true">
          <img style="max-width:100%;max-height:100%" :src="`${GLOBAL.service}img/043img/${roomname}/ivt/${scenename}/${location}/floor.png`" alt="">
        </div>
      </div>
      <div class="towfloorplan" v-show="rightbtntype">
        <!-- 右上角房间列表 -->
        <div    v-for="(data,i) in locationlist" :key="i" >
          <template>
            <div @click="leftindex=i,rightbtn=null" class="btns" :class="{clickbtn:leftindex==i}">{{data.name}}</div>
          </template>
            <template>
                <ul v-show="leftindex==i">
                  <li class="btns" :class="{clickbtn:rightbtn==index}" v-for="(n,index) in data.data" :key="index" @click="setimg(ivtData[scenename][n.location]),rightbtn=index">
                      {{n.name}}
                  </li>
                </ul>
            </template>
        </div>

      </div>
      <div v-show="videotype" style="position: absolute;
    width: 100%;
    height: 100%;background: rgba(9, 9, 9, 0.72);">
    <!-- 视频播放弹窗 -->
    <div style="position: absolute;color: red;
    right: 10px;
    top: 10px ;
    font-size: x-large;
    font-weight: bold;z-index: 100;cursor:pointer" @click="videotype=false">X</div>
       
        <video autoplay loop muted controls style="height:100%;max-height: 100%;
    max-width: 100%;" >
    <!-- :poster="GLOBAL.service+'img/043img/ivt/daytime/Elderly housing-1/showimg.jpg'" -->
          <source :src="`${GLOBAL.service}img/043img/${roomname}/video/roomvideo/043.mp4`" type="video/mp4" />
        </video>
      </div>

      <div id="container"></div>
     
    </div>
    <!-- 图片预加载 -->
  <!-- <div style="display: none;">
    <img  :src="i" v-for="i in urls" :key="i" alt="" @error="imgtype=false">
  </div> -->
  <canvas style="display: none;" id="modelcanvas">

  </canvas>

  </div>
</template>

<script>
import * as THREE from "three";
// import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
// import { OBJLoader } from "three/examples/jsm/loaders/OBJLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { FirstPersonControls } from "three/examples/jsm/controls/FirstPersonControls";
import TWEEN from "tween.js/src/Tween.js";
import { TransformControls } from "three/examples/jsm/controls/TransformControls";
import { DragControls } from "three/examples/jsm/controls/DragControls";
// import model from "./Model.vue"; // 引用
export default {

  data() {
    return {
      mouse:null,
      timer:null,
      videotype:false,
      rightbtn:null,
      leftindex:null,
      nowindex:0,
      leftbtn:false,
      loading: 0,
      loadingindex: true,
      bartype: true,
      tab_index: null,
      room_index: null,
      swiperOption: {
        //轮播
        loop: false, // 循环
        initialSlide: 0, //初始值
        // speed: 800, // 滑动速度
        // direction: "horizontal", //滑动方向
        // grabCursor: true, // 小手掌抓取滑动
        slideToClickedSlide: true, //过渡到选中项
        // observer: true, //
        // observeParents: true,
        slidesPerView: 3,
        centeredSlides: true,
        // spaceBetween: 30,

        pagination: {
          el: ".swiper-pagination",
        },
        navigation: {
          // 无效
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          hideOnClick: true,
        },
        on: {
          click: (e) => {
            // 切换轮播
            console.log(e.realIndex);
          },
        },
      },
     
            locationlist: [
          {name:"Couple Room",data:[{name:"foyer",point:"foyer30",location:'CoupleRoom2'},{name:"room",point:"room30",location:"CoupleRoom1"},{name:"bathroom",point:"bath30",location:"CoupleBath"}]},
          {name:"SENIOR ROOM",data:[{name:"foyer",point:"foyer31",location:"Elderlyhousing2"},{name:"room",point:"room31",location:"Elderlyhousing1"},{name:"bathroom",point:"bath31",location:"ElderlyBath"}]},
          {name:"STUDY room",data:[{name:"foyer",point:"foyer32",location:"study2"},{name:"room",point:"room32",location:"study1"},{name:"bathroom",point:"bath32",location:"studyBath"}]}
          ],
          
      ivtData: this.GLOBAL.data,
      roomname:this.GLOBAL.roomname,
      nowlocation:null,
      audioType: true,
      scenetype: true,
      // 路径合成
      scenename: "daytime",
      location: "Foyer",
      floorplanimg:"img/043img/ivt/structure/Bath 3/showimg.jpg",
      // three.js
      scene: null,
      camera: null,
      point: null, // 光源
      renderer: null,
      orbitControls: null,
      urls: [],
      imgtype:true,
      rightbtntype:false,
      start:null,
      NowModelXYZ:null,
    };
  },

  computed: {
    swiper() {
      return this.$refs.hits.$swiper;
    },
  },
  watch: {
    loadingindex(val, oldval) {
      // 终止加载动画
      if (val >= 100) {
        this.loadingindex = false;
        // console.log(this.loadingindex);
        //然后可以对后台发送一些ajax操作
      }
    },
    
  },

  mounted() {
    //点击事件处理
    window.addEventListener("click", this.onDocumentMouseMove, true);
    document.addEventListener("touchstart", this.onDocumentTouchStart, true);
    // 缩放事件处理
    document.addEventListener("touchmove", this.onDocumentTouchmove, true);
    document.addEventListener("mousewheel", this.onDOMMouseScroll, true);
    // this.swiper.slideTo(3, 1000, false); //设定初始值
    this.nowindex = this.$refs.hits.$swiper.realIndex
    this.nowlocation = this.ivtData[this.scenename].Foyer
    this.location = this.nowlocation.lct;
    // this.floorplanimg = this.ivtData[this.scenename][0].icon
    this.setImgLst();
    // this.loadingimg()
    this.Initialize();
    this.perform();
    this.setpoint(this.nowlocation.point)
    // this.setmodel({x:-15,y:0,z:15,content:"tests",site:"r"})
  },

  methods: {
    getDistance(p1, p2) {
      var x = p2.pageX - p1.pageX,
        y = p2.pageY - p1.pageY;
      return Math.sqrt(x * x + y * y);
    },
    onDocumentTouchmove(e){
      
      if (e.touches.length == 2) {
        console.log("缩放---");
        var now = e.touches;
        var camera2 = this.camera.fov
        var scale =
          this.getDistance(now[0], now[1]) /
          this.getDistance(this.start[0], this.start[1]);
        console.log("获得缩放比例---", scale);

        scale = scale.toFixed(2);
        console.log("比例取整---", scale);
        camera2 /= scale

        if(camera2>25 && camera2 <100){
          this.camera.fov = camera2
        this.camera.updateProjectionMatrix();

        }
      }
    },
    onDOMMouseScroll(e){ //PC相机视野缩放
        // console.log(this.camera)
        var camera2 = this.camera.fov
        if (e.wheelDelta < 0) {
          // console.log("-");
          camera2+=5
        } else {
          // console.log("+");
          camera2-=5
        }
        if(camera2>25 && camera2 <150){
          this.camera.fov = camera2
        this.camera.updateProjectionMatrix();
        // this.renderer.render(scene, camera);
        }

    },
    settowfloor(ivtpath){ // 
      console.log(ivtpath)
      if(this.location != ivtpath){
      this.location = ivtpath;

      }
    },
    // getTextCanvas(text){ 
    //   // 创建贴图文字
    //     var width=512, height=256; 
    //     var canvas = document.createElement('canvas');
    //     canvas.width = width;
    //     canvas.height = height;
    //     var ctx = canvas.getContext('2d');
    //     ctx.fillStyle = '#008080';
    //     ctx.fillRect(0, 0, width, height);
    //     ctx.font = 50+'px " bold';
    //     ctx.fillStyle = '#FFFFFF';
    //     ctx.textAlign = 'center';
    //     ctx.textBaseline = 'middle';
    //     ctx.fillText(text, width/2,height/2); 
    //     return canvas;
    // },

    circle(e){
      // 画圆
      var geometry = new THREE.CircleGeometry( e.modeltype==0? 2:1, 35, 35 );
      var material = new THREE.MeshBasicMaterial( {
        map:new THREE.TextureLoader().load(e.url), 
      side: THREE.DoubleSide} );
      var plane = new THREE.Mesh( geometry, material );
      plane.name=e.name
      plane.location=e.location
      plane.modeltype=e.type
      plane.position.set(e.x,e.y,e.z);
      plane.lookAt(0,e.look,0)
      this.scene.add(plane);
    },

    setmodel(e){
      // 加载介绍模型
        var geometry = new THREE.PlaneGeometry(e.w, e.h, 30 );
        var material = new THREE.MeshBasicMaterial(
          {
            // map:new THREE.CanvasTexture(this.getTextCanvas(e.content)),  // canvas 画图方式
            map:new THREE.TextureLoader().load(`${this.GLOBAL.service}img/043img/btn/${e.content}.png`),
            } );
        var introduce = new THREE.Mesh( geometry, material );
        introduce.name= "model introduce"
        // plane.location=i.location
        introduce.modeltype= 3 // 
      var x = e.x,
          y = e.y,
          z = e.z
        switch (e.site) { //内容展示位置
        // 0 1 2 3 ：上 下 左 右
          case 0:  
            y=e.y+e.h/2+2
            break;
          case 1:  
            y= e.y-e.h/2-2
            break;
          case 2:  
            z= e.z+e.w/1.8
            break;
          case 3:
            x= e.x-e.w/2
              break;
          default:
            break;
        }
        console.log(x,y,z)
        introduce.position.set(x,y,z);
        introduce.lookAt(0,y,0)
        this.scene.add(introduce);
    },
    clickmodel(){ // 点击模型函数
        // return // 中断
        this.raycaster = new THREE.Raycaster();
        if (this.camera) {
          this.raycaster.setFromCamera(this.mouse, this.camera);
        }
          var intersects = this.raycaster.intersectObjects(this.scene.children);
          if(intersects ){
            if(intersects[0].object.modeltype==1){ // 场景设施介绍点
              // console.log("点击场景介绍功能点")
            }else{
            if(intersects[0].object.name !="box1"){
              console.log(intersects[0])
              var point = intersects[0].object
              if(point.name=="sofa"){
                // console.log('click video')
                this.videotype=true
                var video = document.querySelector('video');
                video.play();
              }else{
                this.setimg(this.ivtData[this.scenename][point.location])
                console.log('click point',point.location)
              }
            }
            }

            }
    },
    onDocumentTouchStart(event){ //PHONE
      this.start = event.touches; //得到第一组两个点
      if ( event.touches.length === 1 ) {
      this.mouse = new THREE.Vector2();
        this.mouse.x = (event.touches[ 0 ].pageX  / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.touches[ 0 ].pageY/ window.innerHeight) * 2 + 1;
        // console.log(this.mouse)
         this.clickmodel()
     
      }

    },
    onDocumentMouseMove(event){ // PC
        
      // 
      // console.log(event)
      if (this.timer) {
        clearTimeout(this.timer);
      }
       this.timer = setTimeout(() => {
        this.mouse = new THREE.Vector2();
        this.mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
        this.mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;
        // console.log(this.mouse)
        this.clickmodel()
        
       })
    },
    // loadingimg() {
    //   this.loading = 0;
    //   this.loadingindex = 0;
    //   Array.from(this.urls).forEach((item) => {
    //     let img = new Image();
    //     img.src = item;
    //     img.onload = () => {
    //       this.loading++;
    //       this.loadingindex = (this.loading / 6) * 100;
    //     };
    //   });
    // },
    setImgLst() {
      // 生成贴图列表
      var paths = `${this.GLOBAL.service}img/043img/${this.roomname}/ivt/${this.scenename}/${this.location}/room_`;
      this.urls = [
        paths + "r.jpg", // 左
        paths + "l.jpg", // 右
        paths + "u.jpg", // 顶
        paths + "d.jpg", // 底
        paths + "f.jpg", // 前
        paths + "b.jpg", // 后
      ];
      // this.loadingimg()
      // console.log(this.urls)
    },
    removePoint(){
      //清空场景内的模型点
      this.transformControls.detach(); //停止 模型拖拽控件。
      let pointGroup = []; // 按钮分组
      var group = this.scene.traverse((e)=>{
        if(e.type =="Mesh"){
          // 清除旧场景模型
        if(e.name !="box1"){
          pointGroup.push(e)  // 追加到分组
          // console.log(e.name)
        }else{
        // console.log("不删除")
        }
        }
      })
      if(pointGroup){

      for (const iterator of pointGroup) {
        // 循环删除
        // 清除缓存
        // console.log(333)
        this.scene.remove(iterator)
        iterator.geometry.dispose(); 
        iterator.material.dispose();
        // 删除模型
        
      }
      }

    },
    setpoint(point){
      // 场景加点
      // var pointlist = this.pointlist[point]
      // console.log("场景点",point)
      for (let index = 0; index < point.length; index++) {
        // console.log(point[index])
        const i = point[index];
        var imgurl = `${this.GLOBAL.service}img/043img/btn/place.png` // 跳转点
        var imgurl1 = `${this.GLOBAL.service}img/043img/btn/mark.png` // 介绍点
        let data ={
          name:i.name,
          url:i.type==0? imgurl:imgurl1,
          location:i.location,
          modeltype:i.type,
          x:i.x,
          y:i.y,
          z:i.z,
          look:i.y
        }
        this.circle(data)
        if(i.type == 0){
          // console.log("跳转点")
        }else{
          // console.log("介绍点")
          this.setmodel(i)
          }
      }
      clearTimeout(this.timer);
      this.timer = setTimeout(()=>{   //设置延迟执行
         this.NowModelData();
      },1000)
      
        console.log('场景点加载完成')
    },

    isInArray(arr,value){ // 列表查询
      for(var i = 0; i < arr.length; i++){
              if(value == arr[i]){
                  return true;
              }
          }
    return false;
    },
    setimg(nowlocation) { 
      this.nowlocation = nowlocation
      // console.log("当前位置", this.nowlocation)
      this.location = this.nowlocation.lct // 当前位置实际文件名称
      // 判断侧边按钮是否展示
      var leftbtns = this.isInArray(['Couple Room-2',"Couple Room-1","Bath 3","Elderly housing-2","Elderly housing-1","study-2","study-1"],this.location)

      this.removePoint()  // 清空场景点

      this.nowindex = this.$refs.hits.$swiper.realIndex
      this.$refs.hits.$swiper.slideTo(this.nowlocation.index,100,false) // 更新顶部滑动模块下标

      this.setImgLst(); // 更新贴图列表
      // console.log('this.scene.children',this.scene.children)
      var model = this.scene.getObjectByName("box1")
      model.material = this.lodingsex();  //切换贴图

      if(this.nowlocation.point){ // 创建点
      // console.log(999,this.nowlocation.point)
      this.setpoint(this.nowlocation.point)
      }
      if(this.nowlocation.name =="studio"){

      }
      if(leftbtns && this.scenename !="structure" && this.roomname =="3BR DK-1"){
       // 处理右侧按钮
       this.rightbtntype = true
      }else{
        this.rightbtntype = false
      }
      
      if(this.location == "study-1" ){
        // 沙发视频功能按钮
        let data = {
          name:"sofa",
          type:0,
          url:`${this.GLOBAL.service}img/043img/btn/btn.png`,
          x:-5,
          y:-10,
          z:20,
          look:0,
        }
        this.circle(data)

      // var geometry = new THREE.CircleGeometry( 2, 30, 20 );
      // var material = new THREE.MeshBasicMaterial( {map:new THREE.TextureLoader().load(`${this.GLOBAL.service}img/043img/btn/btn.png`), side: THREE.DoubleSide} );
      // var plane = new THREE.Mesh( geometry, material );
      // plane.name="sofa"
      // plane.position.set(-5, -10, 20);
      // plane.lookAt(0,0,0)
      // this.scene.add(plane);
      }else{
        let sofa = this.scene.getObjectByName("sofa")
        // console.log(sofa)
        if(sofa){
        console.log("sofa-name",sofa)
        // this.scene.remove(sofa)
        }
      }
    },
    lodingsex() {
      // 方便切换贴图，将加载方法提取为独立方法
      this.loading = 0;
      this.loadingindex = true;
      // console.log("加载六面体材质====>>>", this.scene.children);
      var materialArray = [];
      for (var i = 0; i < 6; i++) {
        var texture = new THREE.TextureLoader().load(this.urls[i], () => {
          this.loading += 1; //加载进度
          if (this.loading == 6) {
            this.loadingindex = false;
          }
        });
        // texture.flipY = false //上下翻转
        materialArray.push(
          new THREE.MeshBasicMaterial({
            map: texture, //将图片纹理贴上
            side: THREE.BackSide,
          })
        );
      }
      return materialArray;
    },
    // 初始化
    Initialize() {
      this.scene = null;
      this.camera = null;
      this.renderer = null;
      this.orbitControls = null;
    },
    // three.js
    createScene() {
      // 场景
      this.scene = new THREE.Scene();
    },
    createCamera() {
      //相机
      this.camera = new THREE.PerspectiveCamera(
        75,
        window.innerWidth / window.innerHeight,
        0.1,
        3000
      );

      // 相机位置
      this.camera.position.set(-0.1, 0.1, 0.1); //相机位置
      this.camera.lookAt(10, 1, 0); //看向位置
      this.camera.focus = 30;
      this.scene.add(this.camera);
    },

    createPoint() {
      // 光源
      this.point = new THREE.PointLight(0xffffff, 1, 1000);
      this.point.position.set(0, 0, 0); //点光源位置
      this.point.castShadow = true; // 是否启用动态投影、比较耗性能
      // this.scene.add(this.point);
    },
    addhtml() {
      //场景渲染

      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true,
      });
      // 窗口大小

      this.renderer.setSize(window.innerWidth * 0.97, window.innerHeight * 0.95);
      document
        .getElementById("container")
        .appendChild(this.renderer.domElement);
    },

    skyBox() {
      //内置场景盒子
      var skyGeometry = new THREE.BoxGeometry(500, 500, 500);
      var skyMaterial = new THREE.MeshFaceMaterial(this.lodingsex());
      var skyBox = new THREE.Mesh(skyGeometry, skyMaterial); //创建一个完整的天空盒，填入几何模型和材质的参数
      skyBox.name = "box1";
      skyBox.position.set(0, 0, 0);
      skyBox.scale.x = -1; // 贴图反向
      this.scene.add(skyBox); //在场景中加入天空盒

      // var models3 = new THREE.SphereBufferGeometry(50, 50, 50);
      // var floorLoader = new THREE.TextureLoader();
      // floorLoader.load(
      //   `../../img/043img/ivt/01-01/Night/Couples_room/img.jpg`,
      //   (texture) => {
      //     var material = new THREE.MeshBasicMaterial({
      //       // color: 0x0000ff,
      //       // opacity:0.7,
      //       // transparent: true,
      //       //  color:0x0000ff,
      //       // specular: 0x4488ee,
      //       // specularMap: floorLoader, // 接受光照
      //       // shininess: 40,
      //       side: THREE.BackSide,
      //       // 设置颜色纹理贴图：Texture对象作为材质map属性的属性值
      //       map: texture, //设置颜色贴图属性值
      //     }); //材质对象Material

      //     var testmodel2 = new THREE.Mesh(models3, material);
      //     // testmodel2.castShadow = true; //default is false
      //     // testmodel2.receiveShadow = true; //default
      //     testmodel2.position.set(0, 0, 0);
      //     testmodel2.rotation.set(0, -14.1373, 0);
      //     // this.scene.add(testmodel2);
      //   }
      // );
    },
    animate() {
      // 渲染
      this.renderer.render(this.scene, this.camera);
      // this.setanimation(); // 事件绑定
      window.requestAnimationFrame(() => this.animate());
      // TWEEN.update();
      this.orbitControls.update();
    },

    createevent() {
      // 事件管理、操作控制器 ,旋转控件
      this.orbitControls = new OrbitControls(
        this.camera,
        this.renderer.domElement
      );
      this.orbitControls.enablePan = false; //禁止平滑
      this.orbitControls.enableDamping = true;
      this.orbitControls.dampingFactor = 0.05;

      this.orbitControls.enableZoom = false;
      this.orbitControls.maxDistance = 10; //场景推进
      this.orbitControls.minDistance = 1;

      this.transformControls = new TransformControls(
        this.camera,
        this.renderer.domElement
      );
      this.scene.add(this.transformControls);
    },
    NowModelData() {// 移动模型控件处理
      return // 正式环境禁止移动
      this.DragModel = [];
      if (this.dragControls) {
        // 切换场景时、需要重置一次控制器
        // console.log(123)
        this.dragControls.deactivate();
        this.dragControls.dispose();
      }
      for (let i = 0; i < this.scene.children.length; i++) {
        console.log(this.scene.children[i])
        if (
          this.scene.children[i].isMesh &&
          this.scene.children[i].name != "box1"
        ){
          this.DragModel.push(this.scene.children[i]);
        }
      }
      if(this.DragModel ==[]){
        return
      }
      console.log("动模型列表", this.DragModel);
      this.dragControls = new DragControls(
        this.DragModel,
        this.camera,
        this.renderer.domElement
      );
      // 拖动插件事件监听
      var self = this;
      // this.dragControls.addEventListener("dragstart", function (event) {
      //   // console.log("开始");
      //   self.orbitControls.enabled = false
      // });
      // 拖拽结束
      this.dragControls.addEventListener("dragend", function (event) {
        console.log("结束", event.object.position);
        self.NowModelXYZ = event.object.position
        self.orbitControls.enabled = true;
      });
      this.dragControls.addEventListener("drag", function (event) {
        self.orbitControls.enabled = false;
        // console.log("拖动");
      });

      this.dragControls.addEventListener("hoveron", function (event) {
        self.orbitControls.enabled = false;
        // self.changeMaterial(event.object); // 更改模型颜色
        self.transformControls.attach(event.object);
        self.transformControls.setSize(0.4);
      });
      this.dragControls.addEventListener("hoveroff", function (event) {
        self.orbitControls.enabled = true;
      });
    },
    perform() {
      this.createScene();
      this.createCamera();
      this.addhtml();
      this.createPoint();
      this.skyBox();
      this.createevent();
      this.animate();
    },

    setScene(scene, name) { //场景换装
      this.bartype = true;

      if (scene == "HardOutfit" ) {
        var swipertype = this.isInArray(["Bedroom31","Bedroom32","BedBath"],this.nowlocation.location)
        if (name == "structure" && !swipertype) {
          this.scenename = "daytime";
          this.setimg(this.ivtData[this.scenename][this.nowlocation.location]);
        } else {
          
          if(this.nowlocation.location in this.ivtData.structure){
            console.log('存在点')
            this.scenename = "structure";
            // console.log(this.nowlocation.location)
            this.setimg(this.ivtData[this.scenename][this.nowlocation.location]);
          }else{
            this.scenetype = !this.scenetype; // 处理反向选择
            console.log("不存在点")
            // window.alert("不存在点");
          }

          
        }
      }
      if (scene == "SoftOutfit") {
        // console.log(this.nowlocation)
        if (name == "night") {
          this.scenename = "daytime";
          this.setimg(this.ivtData[this.scenename][this.nowlocation.location]);
        } else {
          this.scenename = "night";
          this.setimg(this.ivtData[this.scenename][this.nowlocation.location]);
        }
      }
      // this.swiperOption.initialSlide = 0
      this.scenetype = !this.scenetype;
      // this.loadingimg()
      // console.log(this.scenename);
    },

    // 音频控制
    soundBtn() {
      if (this.audioType) {
        this.$refs.audio.pause();

      } else {
        this.$refs.audio.play();

      }
      this.audioType = !this.audioType;
    },

    // 横向滑动菜单
    To() {
      console.log(this.$swiper);
      // this.$refs.hits.$swiper.slideTo()
    },
    prev() {
      this.$refs.hits.$swiper.slidePrev();
      // console.log("====>>>>",Object.values(this.ivtData[this.scenename]))
      // 使用 Object.values() 提取json的值、在使用当前下标选定值
      this.setimg(Object.values(this.ivtData[this.scenename])[this.$refs.hits.$swiper.activeIndex]);
      this.nowindex = this.$refs.hits.$swiper.realIndex
    },
    next() {
      this.$refs.hits.$swiper.slideNext();
      // console.log("====>>>>",Object.values(this.ivtData[this.scenename]))
      this.setimg(Object.values(this.ivtData[this.scenename])[this.$refs.hits.$swiper.activeIndex]);
      this.nowindex = this.$refs.hits.$swiper.realIndex
    },
    goPage(pageName, item = "") {
      console.log(pageName, item);
      this.$router
        .push({
          path: pageName,
          query: {
            typename: item,
          },
        })
        .catch((err) => {});
    },
  },
};
</script>

  
<style >
.towfloorplan{
  position: absolute;
  top: 25vh;
  right: 0vw;
  width: auto;
  z-index: 100;
}
.clickbtn{
  background: #705637 !important;
}
.towfloorplan .btns{
  cursor: pointer;
    background: #a97f49;
    border-radius: 25px;
    min-height: 15px;
    padding: 5px;
    margin: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 12px;
    text-transform: uppercase;

}

.leftbtns{
  position: absolute;
  top: 10px;
  right: 10px;
  width:30px;
  height:30px;
  font-size: x-large;
}
.leftbtns:hover{
   cursor: pointer;
}


.middle{
    display: flex;
    justify-content: center;
    align-items: center;
}



.clickfloorplan{
    width: 50% !important;
    height: 50% !important;
     border-radius: 25px;
}
.floorplan{
    position: absolute;
    left: 10px;
    bottom: 10px;
    width: 200px;
    height: 200px;
    border-radius: 10px;
    z-index: 100;
    background: rgba(234, 233, 233, 0.46);;
}
.slidetext{
      position: absolute;
    color: white;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    background: rgba(48, 47, 47, 0.3);
        text-transform: uppercase;
}
.loading {
  width: 100%;
  height: 100%;
  background: #a6adb496;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.title_on {
  position: absolute;
  top: 32vh !important;
  /* bottom:250px !important; */
  width: 100%;
  height: auto;
}
.title_off {
  position: absolute;
  top: 100px;
  bottom: auto;
  width: auto;
  height: auto;
}

.ivt_title {
  position: absolute;
  width: 25%;
  height: 100%;
  display: flex;
  flex-flow: column;
  text-align: start;
  /* left: 5%; */
  justify-content: center;
  align-items: center;
  color: #7a603f;
    left: 1%;
}
.ivt_title img {
  width: 25%;
}
.room_content {
  position: absolute;
  width: 97%;
  height: 95%;
  background-color: white;
  border: 6px solid #7a603f;
}
.pop_list_content {
  width: 67px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  margin: 7px;
}
.pop_list_checked {
  color: #000;
}
.imgs_checked {
  border: 1px solid #000 !important;
}
.pop_details_list {
  width: 100%;
  height: 75%;
  display: grid;
  align-items: center;
  grid-auto-flow: column;
  justify-content: space-around;
  color: white;
  bottom: 0px;
  position: absolute;
  overflow: scroll;
}
.pop_details_list .imgs {
  border: 1px solid #fff;
  width: 40px;
  height: 40px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  margin-bottom: 15px;
}

.imgs:after {
  border: 1px solid #000;
}

.phone_pop_back {
  right: 20px;
  top: 20px;
  position: absolute;
}
.phone_pop_back button {
  background-color: rgba(48, 47, 47, 0.3);
  color: white;
  font-size: larger;
  border: 0px;
}

.phone_pop .title_text {
  position: absolute;
  width: 185px;
  top: 20px;
  text-align: end;
  color: white;
}

.phone .phone_pop {
  width: 100%;
  height: 250px;
  position: fixed;
  /* background-image: url("~@/assets/button/pop_bg.png");
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: 100%; */
  background-color: #7a603f;
  bottom: 45px;
}

.phone {
  display: none;
}
.phone_btn_group .home_btn {
  position: absolute;
  /* top: -77px; */
  width: 150px;
  left: 50%;
  margin-left: -75px;
  bottom: 0px;
}

.phone_btn_group .home_btn img {
  width: 100%;
  height: 100%;
}
.phone_btn_group {
  position: fixed;
  bottom: 0px;
  display: flex;
  align-items: center;
  width: 100%;
  background-color: white;

  /* position: absolute;
  bottom: 0px;
  display: grid;
  width: 100%;
  grid-auto-flow: column;
  background-color: white;
  align-items: baseline;
  grid-template-columns: 15% 15% 40% 15% 15%; */
}

.phone_btn_group .btn {
  width: 100%;
  height: 100%;
  background-color: white;
  margin-bottom: inherit;
  box-shadow: none;
  border-radius: 5px;
  color: #a87f49;
}


.phone_btn_group .btn img {
  max-width: 30px;
  margin: 5px;
}

.pc {
  display: flex;
  justify-content: center;
  position: fixed;
  max-width: 100%;
  height: 35vh;
  top: 0px;
  z-index: 99;
}
.pc .btn {
  width: 100%;
  height: 100%;
  background-color: rgba(97, 97, 97, 0.788);
  margin-bottom: 5px;
  box-shadow: 0px 1px 2px #000;
  border-radius: 5px;
  /* margin: 0px; */
      display: flex;
    justify-content: center;
    align-items: center;
}
.pc .btn img {
  max-width: 30px;
  margin: 5px;
  width: 20%;
}
.pc .btn p{
  margin: 0px;
  width: 80%;
    font-size: 12px;
}

.pc_btn_group {
  position: fixed;
  bottom: 5%;
  /* left: 20px; */
  right: 2%;
  z-index: 999;
}

.swiper-slide-content {
  /* 轮播内容调整 */

  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.swiper-button-prev:after,
.swiper-button-next:after {
  /* 切换按钮样清除原始样式 */
  display: none;
}
.swiper-button-prev,
.swiper-button-next {
  /* 切换按钮样式调整 */
  color: white;
  font-size: var(--swiper-navigation-size);
}

.swiper_back_btn {
  position: absolute;
  right: 20px;
  bottom: 36px;
  top: 30px;
}
.swiper_back_btn button {
  background-color: #7a603f;
  color: white;
  font-size: larger;
  border: 0px;
}

.swiper-wrapper {
  display: flex;
  align-items: center;
}

.swiper {
  height: 100%;
  width: 50%;
}
.swiper-slide-active {
  /* 当前选中轮播样式设定 */
  transition: 300ms;
  transition-property: all;
  transition-duration: 300ms;
  transition-timing-function: ease;
  transition-delay: 0s;
  transform: scale(1) !important;
  box-shadow: 1px 2px 6px #000;
  border-radius: 15px;
  overflow: hidden;
  z-index: 99;
}
.swiper-slide-prev{
  transform: scale(0.5) !important;

}
.swiper-slide-next{
  transform: scale(0.5) !important;

}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  border-radius: 15px;
  transform: scale(0.5) ;
  white-space: nowrap;
  overflow: hidden;
  box-shadow: 0px 0px 20px #2b2626;
  /* background-color: white; */
  height: 80%;
}

.ivt_title_div {
  /* top: 10px; */
  width: 100vw;
  height: 25vh;
  position: absolute;
  /* background-color: #f3f4f5; */
  background-image: url("~@/assets/room/bg.png");
  background-size: cover;
  box-shadow: 0px 2px 10px #000;
}

.ivt_ifarme {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-height: 800px) {
  .towfloorplan{
    right: 17vw;
  }
}
@media screen and (max-width: 1000px) {
  /* .ivt_title img {
    width: 16%;
  } */
  /* .ivt_title_div {
    height: 30vh;
  } */
  /* .pc {
    display: none;
  }
  .phone {
    display: block;
    position: fixed;
    width: 100%;

    z-index: 999;
  } */
}
</style>
